import { setMobileViewAction as setMobileViewOperation } from 'editor/src/store/app/slice';

export default setMobileViewOperation;
